import React, { ReactNode } from 'react';
import clsx from 'clsx';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import HighlightCard from 'components/FinancialCheckup/FinancialDashboard/DashboardActionTiles/HighlightCard';
import { DashboardTileIconTone } from 'components/FinancialCheckup/FinancialDashboard/DashboardActionTiles/types';

import styles from './DashboardTileCard.module.scss';

interface DashboardTileIconProps {
  tone: DashboardTileIconTone;
  children: ReactNode;
  className?: string;
}

export const DashboardTileIcon: React.FC<DashboardTileIconProps> = ({ tone, children, className }) => (
  <div className={clsx(styles.iconCircle, styles[`iconCircle--${tone}`], className)}>{children}</div>
);

interface DashboardTileCardProps {
  title: string;
  description?: string;
  icon: ReactNode;
  iconTone: DashboardTileIconTone;
  isFull?: boolean;
  highlight?: boolean;
  onClick?: () => void;
  className?: string;
}

const DashboardTileCard: React.FC<DashboardTileCardProps> = ({
  title,
  description,
  icon,
  iconTone,
  isFull,
  highlight,
  onClick,
  className,
}) => (
  <HighlightCard highlight={highlight} className={clsx(styles.tile, { [styles.tileFull]: isFull }, className)}>
    <ActionCard
      variant={ActionCardVariant.White}
      onClick={onClick}
      className={clsx(styles.tileCard, {
        [styles.tileCardHighlight]: highlight,
        [styles.tileCardFull]: isFull,
      })}
      contentClassName={clsx(styles.tileContent, { [styles.tileContentFull]: isFull })}
      showChevron
    >
      <DashboardTileIcon tone={iconTone}>{icon}</DashboardTileIcon>
      <div>
        <ActionCard.Title className={styles.tileTitle}>{title}</ActionCard.Title>
        {description && (
          <ActionCard.Description className={styles.tileDescription}>{description}</ActionCard.Description>
        )}
      </div>
    </ActionCard>
  </HighlightCard>
);

export default DashboardTileCard;
